import React from "react";
import { buttonVariants } from "./button";
import { Button } from "./button";
import { Copy } from "lucide-react";

import { Checkbox } from "./checkbox";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { useQuranOptions } from "@/app/providers/QuranContextProvider";
import { QuranResponseType } from "@/lib/types";
import { useRef } from "react";
import ToolTipNavItem from "./tooltip-nav-item";

function QuranAyahCopy({ ayah }: { ayah: QuranResponseType }) {
  const btnCopyText = useRef<HTMLSpanElement>(null);
  const iconCopy = useRef<SVGSVGElement>(null);

  const copyCheckboxWrapref = useRef<HTMLDivElement>(null);

  const {
    activeTranslations,
    quranMushaf,
    quranFont,
    data: globalData,
  } = useQuranOptions();

  const handleCopyAyah = () => {
    if (!copyCheckboxWrapref.current) return [];

    // Get all input elements inside the ref
    const checkboxes = copyCheckboxWrapref.current.querySelectorAll(
      "button[data-state='checked']",
    );

    let dataCopied = "";
    checkboxes.forEach((elem) => {
      const langId = elem.getAttribute("data-lang-id");
      if (langId != "-1") {
        if (
          quranMushaf.type == "indopak15" ||
          quranMushaf.type == "indopak16"
        ) {
        } else {
          // Uthmani
          if (langId != null) {
            dataCopied +=
              globalData.current.Uthmani[quranMushaf.type][ayah.page][
                ayah.verse
              ].translations[langId].translation;
            dataCopied += "\n";
            dataCopied +=
              "(" +
              globalData.current.Uthmani[quranMushaf.type][ayah.page][
                ayah.verse
              ].translations[langId].name +
              ")";
            dataCopied += "\n\n";
          }
        }
      } else {
        ayah.words.map((word) => {
          if (
            quranMushaf.type == "indopak15" ||
            quranMushaf.type == "indopak16"
          ) {
            if ("words_text" in word) {
              dataCopied += " " + word.words_text;
            }
          } else {
            if ("text_uthmani" in word) {
              dataCopied += " " + word.uthmani_hafs;
            }
          }
        });
        dataCopied += "\n\n";
      }
    });
    navigator.clipboard.writeText(dataCopied);

    if (btnCopyText.current != null)
      btnCopyText.current.textContent = "Copied!";
    iconCopy.current?.classList.add("hidden");

    setTimeout(() => {
      if (btnCopyText.current != null) btnCopyText.current.textContent = "Copy";
      iconCopy.current?.classList.remove("hidden");
    }, 2000);
  };
  return (
    <ToolTipNavItem tooltipText="Copy Ayah" direction="top">
      <Dialog>
        <DialogTrigger asChild>
          <div
            className={`${buttonVariants({
              variant: "bgGhost",
            })} h-9 w-9 p-0 cursor-pointer`}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="w-5 h-5"
            >
              <rect width="8" height="4" x="8" y="2" rx="1" ry="1"></rect>
              <path d="M8 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2"></path>
              <path d="M16 4h2a2 2 0 0 1 2 2v4"></path>
              <path d="M21 14H11"></path>
              <path d="m15 10-4 4 4 4"></path>
            </svg>
          </div>
        </DialogTrigger>
        <DialogContent className="sm:max-w-md">
          <DialogHeader>
            <DialogTitle>Share Ayah</DialogTitle>
            <DialogDescription>
              Just copy the text and share with others
            </DialogDescription>
          </DialogHeader>
          <div
            className="flex flex-col  items-left gap-5"
            ref={copyCheckboxWrapref}
          >
            <div className="flex flex-1 gap-2">
              <Checkbox id="copyAyah" data-lang-id="-1" value="ayahOnly" />
              <label
                htmlFor="copyAyah"
                className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
              >
                Copy Ayah Only
              </label>
            </div>

            {activeTranslations.map((lang, index) => {
              return (
                <div key={`langId${lang.id}`} className="flex flex-1 gap-2">
                  <Checkbox
                    data-lang-id={lang.id}
                    id={`langId${lang.id}`}
                    value={lang.name}
                  />
                  <label
                    htmlFor={`langId${lang.id}`}
                    className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
                  >
                    {lang.name} ({lang.language})
                  </label>
                </div>
              );
            })}

            <Button
              onClick={handleCopyAyah}
              type="submit"
              size="sm"
              className="px-3 flex items-center gap-1"
            >
              <Copy ref={iconCopy} />
              <span className="text-lg" ref={btnCopyText}>
                Copy
              </span>
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </ToolTipNavItem>
  );
}

export default QuranAyahCopy;
